import { AritoIcon, AritoFormV2, BottomActionBarV2, DialogV2, HeaderTabsV2 } from '@/components/custom/erp';
import { BasicInfoTab, GeneralTab, ObjectTab, OtherTab } from './tabs';
import { SearchFormValues, searchSchema } from '../schema';
import { useSearchFieldStates } from '../hooks';

interface InitialSearchDialogProps {
  onClose: () => void;
  onSearch: (values: SearchFormValues) => Promise<void>;
  initialValues: SearchFormValues;
}

export default function SearchDialog({ onClose, onSearch, initialValues }: InitialSearchDialogProps) {
  const searchFieldStates = useSearchFieldStates();
  const { state } = searchFieldStates;

  const handleSubmit = (data: SearchFormValues) => {
    const combinedData = {
      ...data,
      ma_kho: state.khoHang?.uuid || null,
      tk_vt: state.taiKhoanCo?.uuid || null,
      tk_du: state.taiKhoanNo?.uuid || null,
      ma_kh: state.khachHang?.uuid || null,
      ma_nt: state.ngoaiTe?.uuid || null,
      ma_bp: state.boPhan?.uuid || null,
      ma_vv: state.vuViec?.uuid || null,
      ma_hd: state.hopDong?.uuid || null,
      ma_dtt: state.dotThanhToan?.uuid || null,
      ma_ku: state.kheUoc?.uuid || null,
      ma_phi: state.phi?.uuid || null,
      ma_sp: state.sanPham?.uuid || null
    };
    onSearch(combinedData);
  };

  const tabs = [
    {
      id: 'general',
      label: 'Chi tiết',
      component: <GeneralTab searchState={searchFieldStates} />
    },
    {
      id: 'object',
      label: 'Đối tượng',
      component: <ObjectTab searchState={searchFieldStates} />
    },
    {
      id: 'other',
      label: 'Khác',
      component: <OtherTab searchState={searchFieldStates} />
    }
  ];

  return (
    <DialogV2
      open={true}
      onClose={onClose}
      title='Bảng kê phiếu xuất trả lại nhà cung cấp'
      titleIcon={<AritoIcon icon={699} />}
      maxWidth='lg'
    >
      <div className='flex size-full flex-col overflow-hidden'>
        <div className='max-h-[calc(100vh-120px)] flex-1 overflow-auto'>
          <AritoFormV2<SearchFormValues>
            schema={searchSchema}
            initialData={initialValues}
            onSubmit={handleSubmit}
            className='!static !w-full'
            hasAritoActionBar={false}
            headerFields={
              <div className='max-h-[calc(100vh-150px)] w-[800px] min-w-[800px] overflow-y-auto'>
                <BasicInfoTab />

                <HeaderTabsV2 tabs={tabs} />
              </div>
            }
            bottomBar={<BottomActionBarV2 mode='search' onClose={onClose} />}
          />
        </div>
      </div>
    </DialogV2>
  );
}
